import { createContext } from 'react';

export type DisableTrackingContextType = {
  validatedTrackingState: boolean;
  toggleValidatedTrackingState: () => void;
};

const DisableTrackingContext = createContext<DisableTrackingContextType>({
  validatedTrackingState: false,
  toggleValidatedTrackingState: () => {},
});

export default DisableTrackingContext;
